import { ITableData } from '../../core/models/table';
import { DefaultProductParams } from '../../core/models/defaultProductParams';
import { IProductCard, IProductHistoryTableItem, ProductTypes } from './models';
import { IMasterProductsTableItem } from './masterProductsTableItem';

export interface IProductPacking {
	id: number;
	name: string;
	width: number;
	height: number;
	depth: number;
	photo: string;
	position: number;
	qty?: number;
	weight?: number;
	image?: HTMLImageElement;
}

export interface ICardCreateParams {
	id: number;
	type: ProductTypes;
	isArchived: boolean;
	name?: string;
}

export class ProductCard {
	id: number;
	name: string;
	type: ProductTypes;
	isArchived: boolean;
	params: ProductParams;
	masterProducts: ProductMasterProducts;
	layout: ProductLayout;
	history: ProductHistory;

	constructor(params: ICardCreateParams) {
		this.id = params.id;
		this.type = params.type;
		this.name = params.name;
		this.isArchived = params.isArchived;
	}

	initParams(params: IProductCard): void {
		this.params = new ProductParams(params);
		if (this.params.name) this.name = this.params.name;
	}

	initMasterProducts(params: any): void {
		this.masterProducts = new ProductMasterProducts(params)
	}

	initLayout(params): void {
		this.layout = new ProductLayout(params);
	}

	updateLayout(params): void {
		const data = Object.assign({}, this.layout.data);
		data.results.dataSource.push(...params.results.dataSource);
		this.initLayout(data);
		this.layout.data.next = params.next;
	}

	initHistory(params: ITableData<IProductHistoryTableItem>): void {
		this.history = new ProductHistory(params);
	}

	updateHistory(params): void {
		const data = Object.assign({}, this.history.data);
		data.results.dataSource.push(...params.results.dataSource);
		this.initHistory(data);
		this.history.data.next = params.next;
	}

	get loadedParams(): boolean {
		return !!this.params;
	}

	get loadedMasterProducts(): boolean {
		return !!this.masterProducts;
	}

	get loadedLayout(): boolean {
		return !!this.layout;
	}

	get loadedHistory(): boolean {
		return !!this.history;
	}
}

class ProductParams {
	article: string;
	barcode: string;
	brand_names: string;
	category_paths: string;
	marker_paths: string;
	supplier_names: string;
	price: number;
	stock_qty: number;
	description: string;
	depth: number;
	depth_compression_coef: number;
	height: number;
	height_compression_coef: number;
	is_loose: boolean;
	packing: Array<IProductPacking>;
	photo: string;
	type: ProductTypes;
	width: number;
	width_compression_coef: number;
	name: string;
	master_positions: Array<{ url: string; name: string }>;

	constructor(params: IProductCard) {
		const defaultParams: DefaultProductParams = new DefaultProductParams();
		this.article = params.article;
		this.barcode = params.barcode;
		this.brand_names = params.brand_names;
		this.category_paths = params.category_paths;
		this.description = params.description;
		this.depth = params.depth || defaultParams.depth;
		this.depth_compression_coef = params.depth_compression_coef || defaultParams.depth_compression_coef;
		this.height = params.height || defaultParams.height;
		this.height_compression_coef = params.height_compression_coef || defaultParams.height_compression_coef;
		this.is_loose = !!params.is_loose;
		this.marker_paths = params.marker_paths;
		this.name = params.name;
		this.packing = params.packing ? [...params.packing] : [];
		this.photo = params.photo;
		this.price = params.price;
		this.stock_qty = params.stock_qty;
		this.supplier_names = params.supplier_names;
		this.width = params.width || defaultParams.width;
		this.width_compression_coef = params.width_compression_coef || defaultParams.width_compression_coef;
		this.master_positions = params.master_positions || [];
	}
}

export class ProductMasterProducts {
	data: ITableData<IMasterProductsTableItem>;

	constructor(params: ITableData<IMasterProductsTableItem>) {
		this.data = params;
	}
}

class ProductLayout {
	data: ITableData<any>;

	constructor(params: ITableData<any>) {
		this.data = params;
	}

	update(params): void {
		this.data.results.dataSource.push(...params.results.dataSource);
	}
}

class ProductHistory {
	data: ITableData<IProductHistoryTableItem>;

	constructor(params: ITableData<IProductHistoryTableItem>) {
		this.data = params;
	}

	update(params: ITableData<IProductHistoryTableItem>): void {
		this.data.results.dataSource.push(...params.results.dataSource);
	}
}